import { createGlobalStyle as css } from 'styled-components'

export const GlobalStyles = css`
  body {
    margin: 0;
    padding: 0;
    background-color: ${({ theme }) => theme.colors.background};
    font-family: 'Poppins', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 1rem;
    font-weight: 400;
    width: 100vw;
    height: 100vh;
  }

  main {
    z-index: 0;
    background-color: ${({ theme }) => theme.colors.background};
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
    padding: 0;
    font-family: 'Poppins', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 1rem;
    font-weight: 400;
    display: inline-block;
  }

  button,
  input,
  textarea {
    margin: 0;
    padding: 0;
    border: none;
    background-color: transparent;
    font-family: 'Poppins', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 1rem;
  }

  button:hover {
    cursor: pointer;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  #root {
    width: 100%;
    height: 100%;
  }

  @media (max-width: 1024px) {
    html {
      font-size: 87.5%;
    }
  }
`
